import { Card } from "@/app/admin/_common/ui/card";
import { Skeleton } from "@/app/admin/_common/ui/skeleton";

export default function PromoDetailSkeleton() {
  return (
    <div className="flex min-h-0 flex-1 flex-col gap-5">
      <div className="grid grid-cols-2 gap-2.5 sm:grid-cols-5">
        {Array.from({ length: 5 }).map((_, i) => (
          <Card key={i} className="rounded-md p-3.5 shadow-none">
            <Skeleton className="mb-2 h-3 w-20" />
            <Skeleton className="mb-2 h-5 w-16" />
            <Skeleton className="h-3 w-12" />
          </Card>
        ))}
      </div>

      <div className="flex min-h-0 flex-1 flex-col gap-2">
        <Skeleton className="h-3.5 w-16" />
        <div className="flex flex-wrap items-center gap-2">
          <Skeleton className="h-[30px] max-w-[420px] flex-1 rounded-md" />
          <Skeleton className="h-[30px] w-[130px] rounded-md" />
        </div>
        <div className="flex min-h-0 flex-1 flex-col overflow-hidden border-t border-border bg-card md:rounded-md md:border md:border-border">
          <div className="flex h-8 items-center gap-4 border-b border-border/50 bg-muted/50 px-4">
            {Array.from({ length: 8 }).map((_, i) => (
              <Skeleton key={i} className="h-3 w-16" />
            ))}
          </div>
          {Array.from({ length: 8 }).map((_, i) => (
            <div
              key={i}
              className="flex h-[42px] items-center gap-4 border-b border-border/50 px-4 last:border-0"
            >
              {Array.from({ length: 8 }).map((_, j) => (
                <Skeleton key={j} className="h-3 w-16" />
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
